import React from 'react';

import { PageMeta } from '../../components/page-meta';

const LandingPublic = ({ route, history, match }) => {
  const Page = route.page;
  return (
    <div className="app">
      <PageMeta {...route.meta} />
      <Page {...route} history={history} match={match} />
    </div>
  );
};

export default LandingPublic;
